// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-event_container__42kNN"};